import { Typography } from '@smartgift/frontend-toolkit';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const InfoWrapper = styled.div`
  background: var(--color-blue-50);
  border: 1px solid var(--color-blue-100);
  border-radius: var(--size-border-radius-md);
  margin-bottom: 16px;
  padding: 16px;
  position: relative;
`;

const Wrapper = styled.div`
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

const HeadTitle = styled(Typography)`
  margin-bottom: 16px;
  text-align: center;
  width: 100%;
`;

const PageContent = styled.div`
  display: flex;
  gap: 40px;
`;

const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 550px;
  min-width: 432px;
`;

const NavigationSecondaryContent = styled.div``;

const RotateAnimation = styled(motion.span)``;

const BannerBadgeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

const CustomApprovalNotificationContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
`;

export {
  BannerBadgeWrapper,
  CustomApprovalNotificationContent,
  HeadTitle,
  InfoWrapper,
  NavigationSecondaryContent,
  PageContent,
  RightContent,
  RotateAnimation,
  Wrapper
};
